module.exports = __webpack_public_path__ + "img/brand_10.abbdd8a4.png";